import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ClientPolicyParticipants } from '@models/swagger';
import { ParticipantsParams } from './service';

export enum ParticipantsActions {
  Failure = '[Application Utilities Participants] Failure',
  Request = '[Application Utilities Participants] Request',
  Success = '[Application Utilities Participants] Success',
}

export const ParticipantsFailure = createAction(ParticipantsActions.Failure, props<{ error: HttpErrorResponse }>());

export const ParticipantsRequest = createAction(
  ParticipantsActions.Request,
  props<{ parameters: ParticipantsParams }>()
);

export const ParticipantsSuccess = createAction(
  ParticipantsActions.Success,
  props<{ data: ClientPolicyParticipants[] }>()
);
